import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'https://downsconstructionllc.com/assets/svgs/service1.svg',
    iconAlt: 'addition icon',
    title: 'Home Additions',
    desc: 'Expand your living space with custom home additions designed for comfort, function, and long-term value.',
    href: '/services/additions',
  },
  {
    icon: 'https://downsconstructionllc.com/assets/svgs/service2.svg',
    iconAlt: 'renovation icon',
    title: 'Interior & Exterior Renovations',
    desc: 'From kitchen remodels to exterior facelifts, we revitalize homes with clean, high-standard construction.',
    href: '/services/renovations',
  },
  {
    icon: 'https://downsconstructionllc.com/assets/svgs/service3.svg',
    iconAlt: 'pole barn icon',
    title: 'Pole Barn Construction',
    desc: 'We build durable, functional pole barns tailored for workshops, storage, agriculture, and more.',
    href: '/services/pole-barns',
  },
];

export default function ServicesSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="services" className="bg-primary-dark py-0">
      <div
        ref={ref}
        className={`grid grid-cols-1 md:grid-cols-3 transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        {services.map((svc, i) => (
          <div
            key={svc.title}
            className="group flex flex-col items-start gap-4 px-8 sm:px-10 py-12 border-b md:border-b-0 md:border-r border-white/10 last:border-0 hover-card hover:bg-primary/80 cursor-default"
            style={{ transitionDelay: `${i * 120}ms` }}
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/10 group-hover:bg-primary-mid/40 rounded-md mb-2 transition-colors duration-300">
              <img src={svc.icon} alt={svc.iconAlt} className="w-8 h-8" />
            </div>
            <h2 className="text-xl font-bold text-white uppercase tracking-wide leading-snug" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
              {svc.title}
            </h2>
            <p className="text-blue-200/70 text-sm leading-relaxed">{svc.desc}</p>
            <Link
              to={svc.href}
              className="mt-auto text-primary-light hover:text-white text-xs font-bold uppercase tracking-widest flex items-center gap-1 cursor-pointer transition-all duration-200 group/link"
            >
              Learn More
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover/link:translate-x-1"></i>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
